<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading" id="also-by">
<div class="heading heading-with-title heading-without-image" id="also-by-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also by CJ Carver</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content"><b><span class="underline"><span class="smallcaps">THE HARRY HOPE SERIES</span></span></b></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><span class="content-external-link">Cold Echo</span></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><span class="content-external-link">Deep Black Lies</span></p>
</div>
</div>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" src="images/break-section-side-screen.png"/>
</div>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content"><b><span class="underline"><span class="smallcaps">THE LIA SHAN THRILLER</span></span></b></p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Snow Thief</p>
</div>
</div>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" src="images/break-section-side-screen.png"/>
</div>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content"><b><span class="underline"><span class="smallcaps">THE NICK ASHDOWN THRILLER</span></span></b></p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Over Your Shoulder</p>
</div>
</div>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" src="images/break-section-side-screen.png"/>
</div>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content"><b><span class="underline"><span class="smallcaps">THE DAN FORRESTER SERIES</span></span></b></p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Spare Me The Truth</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Tell Me A Lie</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Know Me Now</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Scare Me To Death</p>
</div>
</div>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" src="images/break-section-side-screen.png"/>
</div>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content"><b><span class="underline"><span class="smallcaps">THE JAY MCCAULAY SERIES</span></span></b></p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Gone Without Trace</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Back With Vengeance</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Honest Assassin</p>
</div>
</div>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" src="images/break-section-side-screen.png"/>
</div>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content"><b><span class="underline"><span class="smallcaps">THE INDIA KANE SERIES</span></span></b></p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Blood Junction</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Black Tide</p>
</div>
</div>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" src="images/break-section-side-screen.png"/>
</div>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content"><b><span class="underline"><span class="smallcaps">OTHER NOVELS</span></span></b></p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Dead Heat</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Beneath The Snow</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also-by-cj-carver.vue?2dbfb966